module.exports = __webpack_public_path__ + "928cec2c462bfd75e6981ded51cf7d0d.pdf";